<template>
  <div>
    <x-table
    max-height='500'
      :isshowsize="true"
      url="/pc/finance/details"
      ref="xTable"
      :axiosType="false"
      :params="{ id }"
    >
      <el-table-column label="月份" prop="month"></el-table-column>
      <el-table-column label="残值" prop="salvage"></el-table-column>
    </x-table>
  </div>
</template>
<script>
export default {
  props: {
    id: String,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped></style>
